// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyTemplatesPage_wrapper__ovCwN","title":"EmptyTemplatesPage_title__-t3wi","subtitle":"EmptyTemplatesPage_subtitle__gBMAu","link":"EmptyTemplatesPage_link__W6074"};